
import React from 'react';
import { Palette, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Sparkles } from 'lucide-react';

const CreativeLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Palette,
      title: "Portfólio Criativo",
      subtitle: "Veja nossos trabalhos",
      url: "https://decidedigital.com.br/",
      gradient: "from-pink-400 via-purple-500 to-indigo-500"
    },
    {
      icon: MessageCircle,
      title: "Bate-papo Criativo",
      subtitle: "Vamos criar juntos!",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20Decide%20Digital!",
      gradient: "from-green-400 via-emerald-500 to-teal-500"
    },
    {
      icon: Phone,
      title: "Linha Direta",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-blue-400 via-cyan-500 to-teal-500"
    },
    {
      icon: Mail,
      title: "Correio Criativo",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-purple-400 via-pink-500 to-red-500"
    },
    {
      icon: MapPin,
      title: "Estúdio Criativo",
      subtitle: "Venha nos visitar",
      url: "https://maps.app.goo.gl/67vmppvo3ERddDZQ9",
      gradient: "from-orange-400 via-red-500 to-pink-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 py-8 px-4 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-pink-500/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute top-32 right-8 w-16 h-16 bg-purple-500/20 rounded-full blur-lg animate-bounce"></div>
        <div className="absolute bottom-20 left-16 w-24 h-24 bg-blue-500/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-40 right-12 w-12 h-12 bg-cyan-500/20 rounded-full blur-lg animate-bounce"></div>
      </div>

      <div className="max-w-md mx-auto relative z-10">
        {/* Profile Section */}
        <div className="text-center mb-8">
          <div className="relative inline-block">
            <div className="w-28 h-28 mx-auto mb-4 bg-gradient-to-br from-pink-400 via-purple-500 to-indigo-600 rounded-full flex items-center justify-center shadow-2xl">
              <Palette className="w-12 h-12 text-white" />
            </div>
            <div className="absolute -top-2 -right-2">
              <Sparkles className="w-8 h-8 text-yellow-400 animate-bounce" />
            </div>
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent mb-2">
            Decide Digital
          </h1>
          <h2 className="text-lg text-purple-300 font-medium mb-3">Creative Studio</h2>
          <p className="text-gray-300 leading-relaxed px-4 text-sm">
            ✨ Transformamos ideias em experiências visuais incríveis. 
            Somos apaixonados por criar soluções digitais que encantam e inspiram. 
            Vamos criar algo incrível juntos! 🎨
          </p>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-14 h-14 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center hover:bg-white/20 transition-all duration-300 hover:scale-110 hover:rotate-12"
            >
              <social.icon className="w-6 h-6 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-gradient-to-r ${link.gradient} rounded-3xl text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-rotate-1`}
            >
              <div className="flex items-center">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mr-4">
                  <link.icon className="w-7 h-7" />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
                <Sparkles className="w-5 h-5 opacity-70" />
              </div>
            </a>
          ))}
        </div>

        {/* Creative CTA */}
        <div className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 rounded-3xl p-6 mt-8 text-center text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-white/10 backdrop-blur-sm rounded-3xl"></div>
          <div className="relative z-10">
            <p className="font-bold text-lg mb-1">🚀 Pronto para decolar?</p>
            <p className="text-sm opacity-90">
              Vamos transformar sua visão em realidade digital!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreativeLinktree;
